import React from "react";
import './index.css'

const SkeletonCasinoGroupGameItem = ({secondary = false}) => {


    return (
        <div className={`skeleton-game-item ${secondary ? 'reversed' : ''} `}>
            <div className="skeleton-game-image skeleton"></div>
            {/* Skeleton for game image */}
            <div className="skeleton-game-info">
                <div className="skeleton skeleton-game-title"></div>
            </div>
        </div>
    );
};
export default SkeletonCasinoGroupGameItem
